import sideBarDefaultLogoDarkMode from "@assets/images/sidebar-deafult-logo-darkMode.png";
import { useCloud } from "@dashboard/auth/hooks/useCloud";
import { Avatar, Box, Text, Tooltip } from "@saleor/macaw-ui-next";
import { CloudIcon } from "lucide-react";
import { useState } from "react";
import { FormattedMessage } from "react-intl";

import { useEnvLink } from "./menu/hooks/useEnvLink";

export const MountingPoint = () => {
  // 사이드바는 앱 테마와 무관하게 항상 어두우므로 다크용 로고로 고정한다.
  // 종전에는 테마에 따라 골랐는데, 라이트 테마에서 밝은 배경용 로고가 어두운 바탕에 얹혀
  // 묻혔다. (2026-09-17 KST 수정)
  const logo = sideBarDefaultLogoDarkMode;
  const { isAuthenticatedViaCloud } = useCloud();
  const envLink = useEnvLink();
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Box
      display="flex"
      gap={3}
      paddingX={4}
      // 위 13px + 아바타 24px + 아래 12px + 아래 테두리 1px = 50px 으로 상단 메뉴바와
      // 높이를 맞춘다. 아래만 1px 적은 것은 테두리 몫이다.
      // 종전 paddingY={5} 는 20px 이라 64px 이었다. (2026-09-21 KST 수정)
      __paddingTop="13px"
      __paddingBottom="12px"
      __borderBottomWidth="1px"
      __borderBottomStyle="groove"
      __borderColor="#373c3f"
      alignItems="center"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Avatar.Store src={logo} scheme="accent1" size="small" />
      <Text size={3} fontWeight="bold" __flex="1">
        FarmStore Dashboard
      </Text>
      {isAuthenticatedViaCloud && (
        <>
          <Tooltip>
            <Tooltip.Trigger>
              <Box
                as="a"
                href={envLink}
                target="_blank"
                rel="noopener noreferrer"
                display="flex"
                alignItems="center"
                color="default2"
                paddingRight={1}
                style={{
                  opacity: isHovered ? 1 : 0,
                  transition: "opacity 0.15s ease-in-out",
                }}
                data-test-id="cloud-environment-link"
              >
                <CloudIcon size={16} />
              </Box>
            </Tooltip.Trigger>
            <Tooltip.Content side="bottom">
              <Tooltip.Arrow />
              <Text size={2}>
                <FormattedMessage defaultMessage="Go to Saleor Cloud" id="EXqb2l" />
              </Text>
            </Tooltip.Content>
          </Tooltip>
        </>
      )}
    </Box>
  );
};
